import { BaseSearchDTO } from '../API';
export interface ValuationSearchDTO extends BaseSearchDTO {
  filters?: {
    valuationProfileId?: string;
  };
}
